import React from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { ContextLanguage } from "../../../context/Context.Language";
import {
  TEXT_LOG_IN,
  TEXT_MY_ORDERS,
  TEXT_NO_ORDER,
  TEXT_PLEASE,
  TEXT_TO_SEE_YOUR_ORDER,
} from "../../../utils/useConstants";
import { ICON_EMPTY_ORDER } from "../../../utils/useIcons";
import {
  STYLE_ADDRESS_BG,
  STYLE_IMG_EMPTY_ORDER,
  STYLE_LINK_BLUE,
  STYLE_MAX_WIDTH_DESKTOP,
  STYLE_PADDING_NO_MB,
  STYLE_TEXT_SMS,
} from "../../../utils/useStyle";
import ProgramGoBack from "../../task/render/Program.GoBack";
const OrderBeforeLogin = ({ login }) => {
  const { language } = React.useContext(ContextLanguage);
  const { user } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const location = useLocation();
  return (
    <div className={`${STYLE_MAX_WIDTH_DESKTOP} ${STYLE_PADDING_NO_MB}`}>
      <div className={`${STYLE_ADDRESS_BG}`}>
        <ProgramGoBack title={TEXT_MY_ORDERS[language]} />
        <ICON_EMPTY_ORDER className={STYLE_IMG_EMPTY_ORDER} />
        <div className={STYLE_TEXT_SMS(language)}>
          {user ? (
            TEXT_NO_ORDER[language]
          ) : (
            <div>
              {TEXT_PLEASE[language]}
              <span
                onClick={() => {
                  sessionStorage.setItem("redirect", location.pathname);
                  navigate("/Login");
                }}
                className={`${STYLE_LINK_BLUE} `}
              >
                {TEXT_LOG_IN[language]}
              </span>
              {TEXT_TO_SEE_YOUR_ORDER[language]}
            </div>
          )}
        </div>
      </div>
      {/* <div className={` md:w-64 md:mx-auto  mt-9 ${STYLE_BOTTOM_MIN_H_FULL} `}>
        <BlueButton
          title={login ? TEXT_CREATE_ORDER[language] : TEXT_LOG_IN[language]}
          onClick={() => {
            if (user) {
              navigate("/OurServices");
            } else {
              sessionStorage.setItem("redirect", location.pathname);
              navigate("/Login");
            }
          }}
        />
      </div> */}
    </div>
  );
};

export default OrderBeforeLogin;
